import { ITerm } from '../../types/interfaces';

// tslint:disable-next-line:no-object-literal-type-assertion
export function hasTerm<T>(obj: ITerm<T> = {} as ITerm<T>, val: T): boolean {
  return obj.value === val;
}
